import { sortBrokerList } from "../inputs/program/BrokerSupport";
import LabelledElement from "./LabelledElement";
import { Autocomplete, TextField } from "@mui/material";
import Disabled from "components/common/Disabled";
import { useSelector } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as userSelectors from "store/selectors/user/userSelectors";

const ProducerElement = ({ label, value, onChange }) => {
  const { data: brokers, isLoading } = staticDataService.useListBrokersQuery();
  const sortedBrokers = sortBrokerList(brokers ?? []);
  const isFormsAdmin = useSelector(userSelectors.isFormsAdminUser);

  if (!isFormsAdmin) {
    return <></>;
  }

  return (
    <LabelledElement label={label}>
      <Disabled ifReadOnly>
        <Autocomplete
          disabled={isLoading}
          options={sortedBrokers}
          value={value || null}
          onChange={(_, newValue) =>
            onChange(
              newValue == null
                ? null
                : {
                    id: newValue.id,
                    name: newValue.name,
                    company: newValue.company,
                    address: newValue.address,
                  }
            )
          }
          getOptionLabel={(option) =>
            option?.company
              ? `${option?.name} (${option?.company})`
              : option?.name ?? ""
          }
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          renderInput={(params) => <TextField {...params} size={"small"} />}
        />
      </Disabled>
    </LabelledElement>
  );
};

export default ProducerElement;
